var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":this.$store.state.client.logo}})])
}
var staticRenderFns = []

export { render, staticRenderFns }